const status = Object.freeze({
  InProgress: "In Progress",
  Completed: "Completed",
  Failed: "Failed",
});

export default status;
